<script>
import './stylesheets/components/VsErrorPage';

import VsButton from './VsButton';
import VsLayout from './VsLayout';

export default {
  components: {
    VsLayout,
    VsButton,
  },
  props: {
    heading: String,
    subHeading: String,
    message: String,
  },
  computed: {
    showBackButton() {
      return !document.referrer && window.history.length > 2;
    },
  },
  methods: {
    handleGoBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<template lang='pug'>
.vs-error-page
  vs-layout.vs-error-page__header.bg-brand(horz-align-center-xs, vert-align-center-xs, col-xs)
    h1.text-4xl.tracking-normal(v-if='heading') {{heading}}
    h3.text-xl.tracking-normal(v-if='subHeading') {{subHeading}}
  vs-layout.vs-error-page__body(wrap-xs, horz-align-center-xs, vert-align-center-xs)
    div
      h5.text-lg.tracking-normal(v-if='message') {{message}}
      vs-button.bg-brand.text-white.px-1_25.py-_75.uppercase.hover_bg-brand-900(v-if='showBackButton', text='Go Back', @click='handleGoBack')
</template>